<template>
<div class="chapter">
<div class="inner_page">
<div class="" data-pdf-bookmark="Part III. Meet the Team . . ." data-type="part" epub:type="part" id="d1e1418"><h1 class="PartTitlept"><span href="#/toc01" title="Link target outside of Sample">Meet the Team . . .</span></h1><h1 class="PartTitlept"><span href="#/toc01" title="Link target outside of Sample">EVERYONE WANTS TO BELONG TO THE CLUBS!</span></h1><figure class="Illustrationholderill customimage"><div class="figure"><img alt="Club.png" src="Club.jpg"/></div></figure>
<p class="Head-Level-1h1">Meet the Clubs . . .</p><blockquote>
<p class="Extract-NoIndentext1">BUFORD hails from down the swamp. Some say he’s just a good ol’ boy, but he’s got him one mean tongue. Folks go green when they see</p>
<p class="Extract-NoIndentext1">TOAD MAN!</p>
<p class="Extract-NoIndentext1">Buford Calhoun</p>
<p class="Extract-NoIndentext1">Loxahatchee, Florida</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">JAMAL takes a licking and keeps on ticking. Shoot him, stab him, burn him, and he’ll be back for more. No one can stop </p>
<p class="Extract-NoIndentext1">STUNTMAN!</p>
<p class="Extract-NoIndentext1">Jamal Norwood</p>
<p class="Extract-NoIndentext1">Inglewood, California</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">The best-laid plans develop hiccups when PAUL’s around. He makes men cry “Gesundheit,” and women cry, “Oh, yes, oh, yes, oh, yes.”</p>
<p class="Extract-NoIndentext1">SPASM!</p>
<p class="Extract-NoIndentext1">Paul Blackwell</p>
<p class="Extract-NoIndentext1">Denver, Colorado</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">PEARL knows all the secrets of the sea, and speaks the language of the dolphins and the whales. Go deep with</p>
<p class="Extract-NoIndentext1">DIVER!</p>
<p class="Extract-NoIndentext1">Pearl Olsen</p>
<p class="Extract-NoIndentext1">Honolulu, Hawaii</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">TOM soars above his ancient lands on proud, strong wings, watching, guarding, remembering. Look, up in the sky, it’s</p>
<p class="Extract-NoIndentext1">BRAVE HAWK!</p>
<p class="Extract-NoIndentext1">Tom Diedrich</p>
<p class="Extract-NoIndentext1">Benson, Arizona</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">HALEY floats like a butterfly and hits like a pile driver. Light as a feather in the wind, hard as ton of steel, that’s our</p>
<p class="Extract-NoIndentext1">JADE BLOSSOM!</p>
<p class="Extract-NoIndentext1">Haley Mok</p>
<p class="Extract-NoIndentext1">Redondo Beach, California</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">THADDEUS will knock you down, roll over you, and save your soul. Cry hallelujah, brother, and pray you don’t get in the way of</p>
<p class="Extract-NoIndentext1">HOLY ROLLER!</p>
<p class="Extract-NoIndentext1">Rev. Thaddeus Wintergreen</p>
<p class="Extract-NoIndentext1">Natchez, Mississippi</p></blockquote></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part03.vue?30a20734